import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import React from "react";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import { ampli } from "@/config";
import { zinc } from "@/ui/tokens";

export default React.memo(function UnreadMessagesFilterButton({
  active,
  onToggle,
}: {
  active: boolean;
  onToggle: () => void;
}) {
  return (
    <Box sx={{ display: "flex", bgcolor: zinc[800], px: 1 }}>
      <ButtonBase
        data-sb={TestIds.driverView.unreadFilterToggle}
        onClick={() => {
          onToggle();
          ampli.toggleUnreadView();
        }}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          px: 1.5,
          py: 1,
          borderRadius: 1,
          fontSize: "1rem",
          bgcolor: active ? zinc[600] : zinc[700],
          color: active ? "white" : zinc[300],
          "&:hover": { bgcolor: zinc[600], color: "white" },
          cursor: "pointer",
        }}
      >
        <MarkUnreadChatAltIcon sx={{ fontSize: 20 }} />
        <span>Unread Messages</span>
      </ButtonBase>
    </Box>
  );
});
